// extracted by mini-css-extract-plugin
export default {"floatingLinkPopoverForm":"_7F9x3mbofzm3HrHjINlMrQ==","linkInput":"n5fYuScyLTMyejMmUq8AIA==","buttonsWrapper":"yh-72qBSRIfCYUkIsvqmoA==","checkIcon":"eoNRhvZKP+tJa88CvpQ9tg=="};